import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeliveryForFee } from '../interfaces/deliveryforfee.interface';
import { DeliveryForFeeService } from "../services/deliveryforfee";
import { RouterLink,Router} from '@angular/router';
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule, FormControl, FormGroup, FormBuilder  } from '@angular/forms';

@Component({
  selector: 'app-deliveryforfee',
  imports: [RouterLink,CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './deliveryforfee.html',
  styleUrl: './deliveryforfee.css'
})


export class DeliveryForFeeComponent {

  public deliveryforfees: DeliveryForFee[] = [];
  myForm: FormGroup;

  constructor(private deliveryForFeeService: DeliveryForFeeService, 
      private cdr: ChangeDetectorRef, 
      private router: Router,
      private fb: FormBuilder) 
      {
        this.myForm = this.fb.group(
            {
              
            });
        this.getDeliveryForFees();
      }

public async getDeliveryForFees(): Promise<void> {
      try {
        this.deliveryforfees = await this.deliveryForFeeService.getDeliverForFees();
        this.cdr.detectChanges();
        //this.customers = this.customerService.customers;
        } 
        catch (error) 
        {
          console.error('getDeliveryForFees error',error);
      }
  }

  onEdit( deliveryforfee: DeliveryForFee ): void{
       this.deliveryForFeeService.selectedDeliveryForFee = deliveryforfee;
        this.router.navigateByUrl('editdelivery');
     }
      
async deleteDeliveryForFee( deliveryforfee: DeliveryForFee ): Promise<void>{
      const confirmation = window.confirm(`Are you sure you want to delete ${deliveryforfee.productcode + " - " + deliveryforfee.pdescription}?`);
      if (!confirmation) {
       return;
      }
    try
    {
          await this.deliveryForFeeService.deleteDeliveryForFee(deliveryforfee.id);
           this.getDeliveryForFees();
           this.cdr.detectChanges();
           this.router.navigateByUrl('delivery')

    } catch (error) {
          console.error('deleteDeliveryForFee error',error);
    }
  }

}
